import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import LinkView from '~/features/chatbotV2/components/linkView'
import Simple from '~/features/chatbotV2/components/simple'
import { EChatbotTheme } from '~/features/settings/models'
import useGetAuthSessionQuery from '~/hooks/useGetAuthSessionQuery'
import { EClientPath } from '~/models/api'
import { ECognitoGroups } from '~/models/auth'
import { store } from '~/store'

// Clone of pages/chatbot (v1) — identical UI, wired to chat-service's v2
// WebSocket backend instead of the legacy REST endpoint. See
// features/chatbotV2 for the cloned component tree.
//
// Admin-gated here rather than via the portal's usePrivateRoutesRedirect/
// AdminRestrictedLayout — those force sign-out/redirect any visitor with no
// Cognito session at all, which is wrong for a route under the same
// public, unauthenticated ChatBotLayout every real guest widget uses. A
// non-admin (including a guest with no session whatsoever) landing here
// should just see a plain not-found, not get signed out of anything.
function ChatBotV2Page() {
  const chatbotTheme = store((state) => state.chatbot.layout.selection.theme)
  const { data: authSession, isLoading } = useGetAuthSessionQuery()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isAdmin = (authSession?.groups ?? []).includes(ECognitoGroups.admin)

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      navigate(EClientPath.notFound, { state: { from: pathname } })
    }
  }, [isLoading, isAdmin, navigate, pathname])

  if (isLoading || !isAdmin) {
    return <LoadingWithBackdrop show />
  }

  switch (chatbotTheme) {
    case EChatbotTheme.linkView:
      return <LinkView />
    case EChatbotTheme.simple:
      return <Simple />
    default:
      return <LinkView />
  }
}

export default ChatBotV2Page
